import React, { useEffect } from 'react';

const Redirect = (props: { url: string }): JSX.Element => {
    const { url } = props;
    useEffect(() => {
        window.location.href = url + window.location.search;
    }, [url]);

    return <></>;
};

export default Redirect;
